import { useCallback } from 'react';

import * as Types from './types';
import { useGenericSend } from '../useGenericSend';
import { IServerSendResponse } from '../../types';

export const useGetLoyaltyPoints = () => {
    const send = useGenericSend();

    return useCallback(async (): Promise<IServerSendResponse<Types.ILoyaltyPointsResponseData>> => await send({
        ID: 35203,
        description: 'Get Loyalty Points',
        responses: [35204, 35205]
    }), [send]);
};
